import React from 'react'
import { FormModal } from 'transfix-ui/components/Modals'

interface IModalProps {
  onClose: () => void
  onConfirm: () => void
  selectedShipmentsCount: number
  isAcceptRequest: boolean
  isSingleShipment?: boolean
  disabled: boolean
}

export const SelectedShipmentsConfirmationModal = ({
  disabled,
  isAcceptRequest = false,
  isSingleShipment = false,
  onClose,
  onConfirm,
  selectedShipmentsCount,
}: IModalProps) => {
  const action = isAcceptRequest ? 'accept' : 'reject'
  const shipmentStr = selectedShipmentsCount > 1 ? 'shipments' : 'shipment'
  const displayMessage = isSingleShipment
    ? `Are you sure you want to ${action} this shipment?`
    : `Are you sure you want to ${action} ${selectedShipmentsCount} ${shipmentStr}?`
  return (
    <FormModal
      size={4}
      open
      onClose={onClose}
      title='Are you sure?'
      actions={[
        {
          type: 'dismiss',
          label: 'Cancel',
          dataTest: 'cancel-button',
          action: onClose,
          disabled,
        },
        {
          type: 'confirm',
          label: isAcceptRequest ? 'Accept' : 'Reject',
          dataTest: 'confirm-button',
          action: onConfirm,
          disabled,
        },
      ]}>
      {displayMessage}
    </FormModal>
  )
}
